import React, { FC } from 'react'
import { Box, BoxProps, Text, Textarea, InputProps } from '@chakra-ui/core'

export interface Props {
  title: string
  subtext?: string
  value?: string
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  containerProps?: BoxProps
  titleProps?: BoxProps
  subtextProps?: BoxProps
  inputProps?: InputProps<HTMLTextAreaElement>
}

export const AdditionalInfo: FC<Props> = ({
  title,
  subtext,
  value,
  onChange,
  containerProps = {},
  titleProps = {},
  subtextProps = {},
  inputProps = {},
}) => {
  return (
    <Box paddingX=".8rem" {...containerProps}>
      <Text display="inline-flex" fontSize="sm" {...titleProps}>
        {title}
      </Text>
      {subtext ? (
        <Text display="inline-flex" paddingLeft=".4rem" fontSize="sm" color="gray.100" {...subtextProps}>
          {subtext}
        </Text>
      ) : null}
      <Textarea
        marginTop=".8rem"
        value={value}
        onChange={onChange}
        backgroundColor="gray.300"
        borderColor="gray.200"
        borderRadius=".4rem"
        resize="none"
        size="sm"
        {...inputProps}
      />
    </Box>
  )
}
